import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBYPCOgjUrNsGUnKvaWFTP86B4G46n-P0k",
  authDomain: "meufiel-app.firebaseapp.com",
  projectId: "meufiel-app",
  storageBucket: "meufiel-app.firebasestorage.app",
  messagingSenderId: "313405112256",
  appId: "1:313405112256:web:0605631f9dd47cbdc91225",
  measurementId: "G-B24PYWK9K5"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;